module.exports = __webpack_public_path__ + "img/3d-secure.57a3520b.png";